import React from "react";
import Footer from "../components/layout/Footer";
import Navbar from "../components/layout/Navbar";

function Terms() {
  return (
    <div class="main-container">
      <Navbar />

      <div class="col-12 pricing-page">
        <div id="pricing">
          <div class="price-tag col-lg-10 col-12 ml-auto mr-auto p-0 text-justify">
            <h3 class="text-center">TERMES ET CONDITIONS</h3>
            <p>
              Veuillez lire attentivement les conditions générales fournies
              ci-dessous. Ces conditions établissent les termes et conditions
              juridiquement contraignants pour l'utilisation des services haut
              débit de Tizeti (CIVWifi) (les services) et ces conditions
              régiront votre utilisation des services pendant la période pendant
              laquelle vous êtes abonné pour utiliser les services. Veuillez
              noter que ces conditions peuvent changer de temps à autre et
              s'appliqueront à tous les Services.
              <br />
            </p>
            <ol>
              <li>
                <p>
                  <b>DÉFINITIONS</b>
                  <br />
                  Dans les présentes Conditions, sauf indication contraire du
                  contexte, les mots suivants auront les significations
                  suivantes : "Accord" désigne les présentes Conditions
                  générales telles que lues, comprises et signées par le Client,
                  applicables de temps à autre ; « Partenaire de distribution »
                  désigne une société qui s'associe à Tizeti (CIVWifi) pour
                  vendre les Services ; « Client » désigne toute personne ou
                  organisation qui a accepté d'utiliser l'un des services de
                  Tizeti (CIVWifi) conformément aux présentes conditions
                  générales ; « Autorité gouvernementale » désigne tout
                  gouvernement national, supranational, régional ou local ou
                  organisme gouvernemental, législatif, administratif, fiscal,
                  judiciaire ou appartenant au gouvernement, département,
                  commission, autorité, tribunal, agence ou autre entité
                  exerçant des fonctions exécutives, législatives, judiciaires,
                  les pouvoirs ou fonctions réglementaires ou administratifs du
                  gouvernement ou de toute subdivision de celui-ci, y compris
                  les organismes d'application de la loi dûment autorisés ; et «
                  Services » désigne la fourniture d'Internet à son client et
                  comprend tous les forfaits de services, plans de services,
                  programmes et offres introduits par Tizeti (CIVWifi) de temps
                  à autre.
                </p>
              </li>
              <br />
              <li>
                <p>
                  <b> NOTRE PORTÉE DE SERVICE</b>
                  <br />
                  <ul>
                    <li>
                      <p>
                        Tizeti (CIVWifi) fournira des services d'accès haut
                        débit au client pendant la période pendant laquelle le
                        client a souscrit à l'utilisation des services.
                      </p>
                    </li>
                    <li>
                      <p>
                        Tizeti (CIVWifi) se réserve le droit de retirer,
                        amender, modifier ou supprimer les codes, identifiants,
                        identifiants de messagerie, identifiants d'utilisateur
                        ou mots de passe/s attribués/assignés/partagés par
                        Tizeti (CIVWifi) au Client, à tout moment sans attribuer
                        quelque raison que ce soit.
                      </p>
                    </li>
                    <li>
                      <p>
                        Les Services restent la propriété exclusive de TIZETI
                        (CIVWifi), et le Client est autorisé à les utiliser,
                        uniquement pendant la durée du présent Contrat. Le droit
                        d'utiliser tous les services, applications ou
                        fonctionnalités ou paramètres d'accès, y compris, mais
                        sans s'y limiter, l'identifiant de messagerie,
                        l'identifiant d'utilisateur, le mot de passe, etc.,
                        comme indiqué dans les services, cessera d'exister le
                        jour de l'expiration de votre accord avec Tizeti
                        (CIVWifi).
                      </p>
                    </li>

                    <li>
                      <p>
                        Tizeti (CIVWifi) se réserve le droit de retirer,
                        d'amender, de modifier ou de supprimer des services, des
                        forfaits de services, des plans de services, des
                        programmes, des offres, à tout moment sans en donner de
                        raisons, à condition qu'un avis d'une telle action soit
                        donné à l'utilisateur. dans un délai raisonnable par la
                        suite.
                      </p>
                    </li>

                    <li>
                      <p>
                        Tizeti (CIVWifi) ne sera pas responsable de toute perte,
                        coût ou dommage résultant de transactions que le Client
                        conclut avec des tiers utilisant les Services (ces
                        transactions incluent, sans s'y limiter, l'achat ou la
                        location de biens ou de services auprès de ces tiers ou
                        la commande marchandises d'autres organisations
                        utilisant nos services Internet).
                      </p>
                    </li>

                    <li>
                      <p>
                        Ni Tizeti (CIVWifi) ni les partenaires de distribution
                        ne garantissent que les services seront ininterrompus ou
                        sans erreur ou que toute information, logiciel ou autre
                        matériel accessible sur le service est exempt de virus,
                        vers, chevaux de Troie ou autres composants nuisibles.
                      </p>
                    </li>

                    <li>
                      <p>
                        Ni Tizeti (CIVWifi) ni le partenaire de distribution ne
                        sont responsables de l'installation du matériel ou des
                        logiciels nécessaires au forfait de services et le
                        client doit s'assurer que les personnes compétentes ont
                        fait de même de manière satisfaisante. Sans préjudice de
                        ce qui précède, Tizeti (CIVWifi) ou le partenaire de
                        distribution fournira un service de conseil client sans
                        recours.
                      </p>
                    </li>

                    <li>
                      <p>
                        Tizeti (CIVWifi) ou ses partenaires de distribution ne
                        seront pas responsables des problèmes de compatibilité
                        du matériel/logiciel dans les locaux du client. Le
                        Client reconnaît et accepte expressément par la présente
                        que l'installation des applications sur son matériel
                        doit être effectuée par une personne compétente et
                        Tizeti (CIVWifi) ne sera pas responsable de toute perte
                        ou dommage au matériel du Client (PC/Ordinateur/Serveur)
                        au cours d'une telle installation de maintien du présent
                        accord.
                      </p>
                    </li>

                    <li>
                      <p>
                        Tizeti (CIVWifi) décline toute responsabilité quant au
                        contenu de tout matériel provenant d'autres sites Web,
                        organisations, accessibles via les Services.
                      </p>
                    </li>
                    <li>
                      <p>
                        Tizeti (CIVWifi) se réserve le droit de bloquer l'accès
                        à ces informations qui ne sont pas autorisées par la loi
                        de la République du Côte d'Ivoire et/ou selon les directives des
                        bureaux de représentation honorables autorisés du
                        gouvernement du Côte d'Ivoire.
                      </p>
                    </li>

                    <li>
                      <p>
                        Notre journée commence à 00:00:00 et se termine à
                        23:59:59 et Internet expire à 00:00:00 du jour
                        d'expiration.
                      </p>
                    </li>
                    <li>
                      <p>
                        Les appareils appartiennent à l'entreprise et seront
                        retirés du client si le compte du client est expiré
                        pendant 90 jours.
                      </p>
                    </li>

                    <li>
                      <p>
                        En cas d'endommagement de l'appareil, le client assume
                        l'entière responsabilité. Les prix de remplacement des
                        appareils sont soumis aux forces du marché.
                      </p>
                    </li>

                    <li>
                      <p>
                        Cependant, la sécurité des appareils relève de la
                        responsabilité du client. Par conséquent, il est
                        conseillé au client d'assumer l'entière responsabilité
                        et ses précautions de sécurité dans la protection de
                        l'appareil.
                      </p>
                    </li>

                    <li>
                      <p>
                        Cependant, la sécurité des appareils relève de la
                        responsabilité du client. Par conséquent, il est
                        conseillé au client d'assumer l'entière responsabilité
                        et ses précautions de sécurité dans la protection de
                        l'appareil.
                      </p>
                    </li>
                    <li>
                      <p>
                        La relocalisation d'un CPE fixe est soumise à des frais
                        et doit se faire dans la zone de couverture.
                      </p>
                    </li>

                    <li>
                      <p>
                        En cas d'absence de couverture, le client ne sera pas
                        remboursé lors de l'installation si le client a déjà été
                        installé et confirmé qu'Internet fonctionne ou le
                        remboursement de l'abonnement.
                      </p>
                    </li>

                    <li>
                      <p>
                        La carte du client sera débitée dans les 7 jours si
                        notre appareil n'a pas été récupéré. Le Client est tenu
                        de s'assurer que la carte enregistrée pourra être
                        débitée en cas de besoin, faute de quoi des poursuites
                        judiciaires pourront être engagées.
                      </p>
                    </li>

                    <li>
                      <p>
                        La carte du client sera débitée dans les 7 jours si
                        notre appareil n'a pas été récupéré. Le Client est tenu
                        de s'assurer que la carte enregistrée pourra être
                        débitée en cas de besoin, faute de quoi des poursuites
                        judiciaires pourront être engagées.
                      </p>
                    </li>
                    <li>
                      <p>
                        Il y aura plusieurs SSID sur votre appareil pour le test
                        et le développement. Si pour une raison quelconque vous
                        ne le souhaitez pas, des frais vous seront facturés.
                      </p>
                    </li>

                    <li>
                      <p>
                        Tizeti (CIVWifi) a le droit d'appliquer des restrictions
                        strictes à n'importe quel site en fonction de la demande
                        sur le réseau.
                      </p>
                    </li>
                    <li>
                      <p>
                        Tizeti (CIVWifi) se réserve le droit de mettre à niveau
                        le réseau/la capacité afin de fournir la vitesse de
                        service souhaitée au client, sans information préalable
                        ni du client ni du partenaire de distribution.
                        Cependant, le client comprend et accepte que les
                        services de Tizeti (CIVWifi) peuvent être affectés par
                        des facteurs comprenant, mais sans s'y limiter, le type
                        d'équipement que vous utilisez, le site/serveur Internet
                        visité, la disponibilité du réseau, le nombre
                        d'utilisateurs accédant au réseau Internet dans une
                        zone/emplacement ; la puissance du signal et la distance
                        de l'équipement par rapport à l'antenne la plus proche
                        et les conditions écologiques qui auront un impact sur
                        le fonctionnement à la vitesse souhaitée à tout moment.
                      </p>
                    </li>
                    <li>
                      <p>
                        Le client comprend en outre qu'Internet contient des
                        éléments non édités, dont certains sont sexuellement
                        explicites ou peuvent être offensants pour certaines
                        personnes. L'accès du client à ces matériaux se fera à
                        ses risques et périls. Tizeti (CIVWifi) ou les
                        partenaires de distribution n'ont aucun contrôle sur
                        ceux-ci et déclinent toute responsabilité quant à ces
                        contenus.
                      </p>
                    </li>
                    <li>
                      <p>
                        Tizeti (CIVWifi) observe une politique de tolérance zéro
                        concernant la livraison de spams ou de messages
                        commerciaux indésirables utilisant le Service.
                        Nonobstant toute autre disposition de cet accord, le
                        Client n'enverra pas, ne fera pas envoyer ou ne
                        facilitera pas l'envoi de Spam en utilisant le Service.
                        Les comptes qui envoient du spam ou qui, selon nous,
                        pourraient faciliter le spam peuvent être suspendus et
                        résiliés et Tizeti (CIVWifi) travaillera avec les
                        autorités compétentes en cas de poursuites.
                      </p>
                    </li>
                    <li>
                      <p>
                        Tizeti (CIVWifi) ou son partenaire de distribution se
                        réserve le droit de divulguer les coordonnées du client
                        à tout agent de sécurité, comme l'exige la loi, dans le
                        cas où le compte a été utilisé pour commettre une
                        fraude.
                      </p>
                    </li>
                    <li>
                      <p>
                        Tizeti (CIVWifi) ou son partenaire de distribution ne
                        seront pas tenus responsables si le service est utilisé
                        à des fins d'usurpation d'identité.
                      </p>
                    </li>
                    <li>
                      <p>
                        Tizeti (CIVWifi) demande au client de fournir des
                        informations sur le profil du client au moment de
                        l'inscription.
                      </p>
                    </li>
                  </ul>
                  <br />

                  <li>
                    <p>
                      <b> CONFIDENTIALITÉ</b>
                      <br />
                      <ul>
                        <li>
                          <p>
                            Tizeti (CivWifi) peut fournir les informations du
                            client, en réponse à la demande des autorités
                            gouvernementales ou d'autres administrateurs de
                            sites Web, pour détecter et prévenir les incidents
                            de sécurité, les crimes et poursuivre les
                            contrevenants. Conformément aux lois applicables de
                            la République du Côte d'Ivoire, Tizeti (CivWifi) peut
                            également fournir des informations pour protéger la
                            sécurité nationale. provide information to protect
                            national security.
                          </p>
                        </li>

                        <li>
                          {" "}
                          <p>
                            Des informations supplémentaires relatives à la
                            confidentialité doivent être contenues dans la
                            politique de confidentialité de Tizeti (CivWifi).
                          </p>
                        </li>
                      </ul>
                    </p>
                  </li>
                  <br />

                  <li>
                    <p>
                      <b>OBLIGATIONS DU CLIENT</b>
                      <br /> Vous ne pouvez pas utiliser les Services d'une
                      manière qui risque de dégrader les niveaux de services
                      pour d'autres clients, des tiers et de mettre notre
                      système en danger. Si nous pensons que vous utilisez nos
                      Services de l’une de ces manières, comme mentionné, nous
                      sommes en droit de réduire, suspendre et/ou résilier tout
                      ou partie de nos Services sans vous en aviser au
                      préalable.
                    </p>
                  </li>

                  <br />

                  <li>
                    <p>
                      <b>FORCE MAJEURE</b>
                      <br /> Tizeti (CivWifi) n'est pas responsable du
                      manquement à ses obligations si ce manquement résulte d'un
                      cas de force majeure qui comprend (mais sans s'y limiter)
                      des catastrophes naturelles (y compris un incendie, une
                      inondation, un tremblement de terre, une tempête, un
                      ouragan ou autre catastrophe naturelle), guerre, invasion,
                      acte d'ennemis étrangers, hostilités (indépendamment du
                      fait que la guerre soit déclarée), guerre civile,
                      rébellion, révolution, insurrection, pouvoir militaire ou
                      usurpé ou confiscation, activités terroristes,
                      nationalisation, sanction gouvernementale, blocage,
                      embargo, conflit du travail, grève, lock-out ou conflits
                      du travail ou interruption ou panne du service
                      d'électricité ou de télécommunications ; actions du
                      régulateur ou des gouvernements locaux ou nationaux ou
                      d’autres autorités.
                    </p>
                  </li>

                  <br />
                  <li>
                    <p>
                      <b>SUSPENSION DES PRESTATIONS</b>
                      <br /> Tizeti (CivWifi) peut suspendre tout ou partie
                      des Services immédiatement et sans préavis si : les
                      paiements effectués à Tizeti n'ont pas été réalisés pour
                      quelque raison que ce soit en raison de la faute du Client
                      ; Tizeti (CivWifi) doit le faire en vertu de la loi ou
                      conformément à un accord ; Tizeti (CivWifi) a des
                      raisons de croire que le Client a fourni à Tizeti
                      (CivWifi) des informations fausses, inexactes ou
                      trompeuses soit dans le but d'obtenir nos Services et/ou
                      Dispositifs d'accès ; Tizeti (CivWifi) estime que le
                      Client ou une autre personne au bureau ou au domicile du
                      Client a commis, ou pourrait commettre, tout acte qui
                      contrevient aux termes du Contrat de services en utilisant
                      les Services ; ou Tizeti (CivWifi) doit effectuer toute
                      maintenance, réparation ou amélioration de toute partie de
                      ses services ou de ses systèmes,
                    </p>
                  </li>
                  <br />

                  <li>
                    <p>
                      <b> AVIS DE NON-RESPONSABILITÉ </b>
                      <br />
                      Bien que tous les efforts soient déployés par Tizeti
                      (CivWifi) pour fournir la plus haute qualité de service,
                      le client reconnaît que le réseau Tizeti (CivWifi) est
                      interconnecté avec des liaisons Internet haut débit
                      fournies par d'autres fournisseurs de services/entités qui
                      sont responsables de maintenir ces liens aussi fiables.
                      que possible. Tizeti (CivWifi) n'assume aucune
                      responsabilité en cas d'interruptions du réseau
                      d'interconnexion échappant à son contrôle raisonnable.
                      Tizeti (CivWifi) ne sera en aucun cas responsable de
                      toute interruption causée par la qualité de ces liens,
                      d'un défaut de connectivité ou de tout inconvénient,
                      dommage ou toute autre responsabilité de quelque nature
                      que ce soit disparaît du Client ou de toute autre personne
                      à cet égard.
                    </p>
                  </li>

                  <br />

                  <li>
                    <p>
                      <b> AMENDEMENT DES TERMES ET CONDITIONS </b>
                      <br /> Tizeti (CivWifi) peut à tout moment améliorer, modifier, amender ou altérer les termes et conditions des Services s'il y a des frais ou un amendement à toute loi ou réglementation qui s'applique à Tizeti (CivWifi) ou aux Services ; Tizeti (CivWifi) décide que les Services doivent être modifiés pour des raisons de qualité de service ou autrement dans l'intérêt de ses clients ou, selon l'option raisonnable de Tizeti (CivWifi), il est nécessaire de le faire ; pour des raisons de sécurité, techniques ou opérationnelles ; dans tous les autres cas, où Tizeti (CivWifi) détermine raisonnablement que toute modification de son système ou changement dans ses pratiques ou politiques commerciales, opérationnelles ou commerciales est nécessaire pour maintenir ou améliorer les Services.
                    </p>
                  </li>

                  <br />

                  <li>
                    <p>
                      <b> LITIGES
 </b>
                      <br /> Tout litige pouvant découler de l'interprétation ou de l'application des présentes conditions générales sera, le cas échéant, tranché par un tribunal compétent siégeant à Accra et la loi applicable sera celle de la République du Côte d'Ivoire.
                    </p>
                  </li>
                </p>
              </li>
            </ol>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Terms;
